import React from 'react';
import { DisplayableSearchResult } from '../types';
import { addUtmParametersToUrl } from '../utils';

interface WebpageCardProps {
    webpage: DisplayableSearchResult;
}

export const WebpageCard: React.FC<WebpageCardProps> = ({ webpage }) => {
    const urlWithUtm = addUtmParametersToUrl(webpage.link);

    return (
        <a
            href={urlWithUtm}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex flex-col items-start p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors no-underline"
            style={{ textDecoration: 'none', maxWidth: '280px' }}
        >
            <span className="text-xs font-medium text-[#0066CC] hover:text-[#004499] truncate block w-full">
                {webpage.title}
            </span>
            <span className="text-xs text-gray-500 truncate block w-full mt-0.5">
                {webpage.link.replace(/^https?:\/\//, '').split('/')[0]}
            </span>
        </a>
    );
};
